import React, { useState } from "react";
import { Button, Box, Typography, Snackbar, Alert, useMediaQuery, Tooltip } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import axios from "axios";
import { useLanguage } from "../context/LanguageContext.js";
import { logDev } from "../utils/logger.js";

const BoutonEnvoyerEmailSondage = ({ groupeId, destinataires, nomGroupe, snackbar, setSnackbar, sondageVerrouille }) => {
  const { t, locale } = useLanguage();

  logDev("📧 [Email] Contexte langue", { locale, test: t("SendSurveyEmail") });
  
  const isMobile = useMediaQuery("(max-width:600px)");
  const [loading, setLoading] = useState(false);
  const [cooldown, setCooldown] = useState(false);
  
  const hasEmails = destinataires && destinataires.length > 0;

  const handleSendEmail = async () => {
    if (!hasEmails) {
      setSnackbar({
        open: true,
        message: t("NoValidEmail"),
        severity: "warning"
      });
      return;
    }

    if (cooldown) { 
      setSnackbar({ 
        open: true, 
        message: t("PleaseWaitBeforeSendingAgain"), 
        severity: "info" 
      }); 
      return; 
    }

    setCooldown(true);
    setLoading(true);


    try {
      const lienSondage = `${window.location.origin}/sondage/${groupeId}`;
      const payload = {
        destinataires,
        groupeId,
        nomGroupe,
        langue: locale || "fr" 
      };

      await axios.post(`${process.env.REACT_APP_API}/emails/send-survey`, payload);

      setSnackbar({
        open: true,
        message: `${t("EmailSent")} (${destinataires.length} ${t("Participants")})`,
        severity: "success"
      });
    } catch (err) {
      logDev("❌ Erreur envoi email sondage", { message: err.message, stack: err.stack });
      setSnackbar({
        open: true,
        message: t("ErrorSendingEmail"),
        severity: "error"
      });
    } finally {
      setLoading(false);
      setTimeout(() => setCooldown(false), 60000); // cooldown de 20 secondes
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      <Tooltip
        title={hasEmails ? t("SendSurveyEmail") : t("NoValidEmail")}
        arrow
        placement="top"
      >
        <span>
          <Button
            variant="contained"
            onClick={handleSendEmail}
            disabled={loading || sondageVerrouille || !hasEmails}
            sx={{
              backgroundColor: (loading || sondageVerrouille || !hasEmails) ? "#ccc !important" : "#4CAF50 !important",
              color: "#fff !important",
              fontWeight: "bold",
              fontSize: isMobile ? "0.5rem" : "0.7rem",
              padding: "10px 20px",
              borderRadius: 1,
              "&:hover": {
                backgroundColor: "#388E3C",
                transform: hasEmails ? "scale(1.05)" : "none"
              }
            }}
          >
            <EmailIcon sx={{ mr: 1 }} />
            {t("SendSurveyEmail")}
          </Button>
        </span>
      </Tooltip>

      <Typography
        variant="caption"
        sx={{
          mt: 1,
          color: "#555",
          textAlign: "center"
        }}
      >
        {hasEmails
          ? `${destinataires.length} ${t("EmailsAvailable")}`
          : t("NoValidEmail")}
      </Typography>
    </Box>

  //le snackbar est géré dans sondage
    
  );
};

export default BoutonEnvoyerEmailSondage;
